@file:OptIn(androidx.compose.ui.ExperimentalComposeUiApi::class)

package com.taocent.simple.compose.component.richtext.core.platform

import androidx.compose.ui.input.pointer.PointerButton
import androidx.compose.ui.input.pointer.PointerEvent
import androidx.compose.ui.input.pointer.PointerEventType

/**
 * 「右键 Press → 拦截 + 弹自定义工具栏」的核心派发判断(纯函数,放 jsMain)。
 *
 * **为什么放 jsMain 而不是 commonMain**:
 * - `PointerButton` / `PointerEventType` / `PointerEvent` 在 KMP 1.11.1 中
 *   **只在 skikoMain 定义**(Desktop + Web 共享),Android 平台不存在。commonMain
 *   引用 `PointerButton.Secondary` 会导致 `:richtext-core:compileAndroidMain`
 *   报 `Unresolved reference 'PointerButton'`(项目 2026-06-13 痛批铁律)。
 * - 抽到 jsMain 后,jvm / wasmJs 各自复制粘贴一份(逻辑完全相同,3 平台 pure 复制)。
 *
 * **调用方式**:同 jvmMain 版本,见 `RichTextContextMenuFilter.kt` 内注释。
 */
internal fun isContextMenuTrigger(event: PointerEvent): Boolean =
    isContextMenuTriggerByEnum(event.type, event.button)

/**
 * 由 [isContextMenuTrigger] 拆出的纯枚举判断。详细契约见 jvmMain 版本的同名函数。
 */
internal fun isContextMenuTriggerByEnum(
    type: PointerEventType,
    button: PointerButton?,
): Boolean = type == PointerEventType.Press && button == PointerButton.Secondary
